export const borderStyling = (value?: unknown): string =>
  value ? "tomato" : "";
